/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ClipboardIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "clipboard", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M8 5.5H6.5V19.5H18.5V5.5H17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 3C13.5 3 13.5 4.5 14 4.5C15 4.5 15.6 5 15.6 6.5H9.5C9.5 5 10 4.5 11 4.5C11.5 4.5 11.5 3 12.5 3Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ClipboardIcon);
export default ForwardRef;
//# sourceMappingURL=clipboardIcon.js.map